import * as Sentry from '@sentry/browser';
import { useCallback, useContext, useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { ReactTinyLink } from 'react-tiny-link';
import scheduleMessage from './scheduleMessage';
import './task.css';
import TaskSecondStep from './taskSecondStep';
import { StarsFillIcon } from 'src/assets/icons';

import {
  Alert,
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Icon,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  UncontrolledTooltip,
} from '@polichat/flamboyant';
import { Picker } from 'emoji-mart';
import 'emoji-mart/css/emoji-mart.css';
import poliApiGatewayRequest from '../../../../utils/poliApiGatewayRequest';
import { useGlotaT } from 'src/hooks/useGlotaTranslation';

import { bindActionCreators } from 'redux';
import * as ChatActions from '../../../../store/modules/chat/actions';

import setBgColorMessages from '../../../../utils/backgroundColorMessages';

import { isMobile } from 'react-device-detect';
import { toast } from 'react-toastify';
import { mountMessage } from '../../../../store/modules/chat/functions';
import ButtonRecordAudio from './audio/ButtonRecordAudio';
import RecordAudioBase64 from './audio/RecordAudioBase64';

import ChannelSelector from './ChannelSelector';
import ChannelSelectorNew from './ChannelSelectorNew';
import ContactExternalSelector from './ContactExternalSelector';
import PreviewThumbnail from './preview/previewThumbnail/index.tsx';
import {
  QuickMessages,
  QuickMessageSelector,
} from './quickMessages/QuickMessages';

import Audio from '../../message-types/audio/Audio.component';
import CartPanel from './cart/CartPanel';
import CatalogCarousel from './catalog/CatalogCarousel';
import CartImage from './modals/src/CartImage';
import PayImage from './modals/src/PayImage';

import { getMessageBuilderTemplateText } from './quickMessages/functions/getMessageBuilderTemplateText';

import { useFlags } from 'flagsmith/react';
import { useWhiteLabel } from '../../../../hooks/useWhiteLabel';
import { isJson } from '../../../../utils/isJson';
import poliConfig from '../../../../utils/poliConfig';
import CustomBox from '../../../common/structure/header/CustomBox';
import { CustomerChannelBalanceContext } from '../contexts/customerChannelBalance/context';

import { QuickMessageSelectorV2 } from './quickMessages/v2';
import { useQuickMessageSelectorFlag } from './quickMessages/v2/hooks/useFlag';
import { useGetQuickMessageFromShortcut } from './quickMessages/v2/hooks/useGetQuickMessageFromShortcut';
import { KeyboardCodes } from './quickMessages/v2/types/constants';
import { useScheduleMessage } from './useScheduleMessageFlag';
import CallAfterInactivity from './CallAfterInactivity';
import { customUseFlags } from 'src/hooks/customUseFlags';
import { useTextAreaContext } from '../contexts/textArea/context';
import { useCopilotAnswer } from '../contexts/copilotAnswer/context';
import { useImproveAnswer } from '../contexts/improveAnswer/context';
import { ModalImproveAnswerSettings } from './ImproveAnswer/components/settings';
import { CopilotAnswerComponent } from './CopilotAnswer';
import { useTrigger } from 'src/hooks/useTrigger';
import { useOverdueCustomer } from 'src/contexts/OverdueCustomerContext';
import { useWabaBlockAt100Credits } from 'src/hooks/useWabaBlockAt100Credits';
import { ChannelCreditsAlert } from './ChannelCreditsAlert';

function TextBox({
  blockInteraction,
  setBlockInteraction,
  chat,
  opennedChat,
  addMessage,
  sendMessage,
  getProtocol,
  updateMessageTextArea,
  updateChatDropzone,
  toggleQuickMessagesSelector,
  navQuickMessagesSelector,
  searchQuickMessages,
  clearReplyingMessage,
  openCatalogCarousel,
  closeCatalogCarousel,
  isEnabledByUserSettings,
}) {
  QuickMessages.setState(chat);

  const MAX_TEXT_LENGTH_BEFORE_IMPROVE = 3;

  const {
    setInputText: setInputTextFromContext,
    setFocusedTextArea,
    setInsertTextHandler,
    insertText,
    focusedTextArea,
    clearChatTrigger,
    setClearChatTrigger,
  } = useTextAreaContext();

  const { isSuspended } = useOverdueCustomer();

  const [emojiPickerState, setEmojiPicker] = useState(false);
  const currentUser = chat?.config?.user;
  // const oldOpennedChatId = opennedChat?.chat?.id;
  const [isWindow24Open, setIsWindow24Open] = useState(false);

  const [isZapiOrWebchat, setIsZapiOrWebchat] = useState(false);

  const chatOwner = opennedChat?.chat?.origin_id;

  const quickMessagesIsOpen = chat.quickMessages?.isOpen;

  const showCatalogCarousel = opennedChat.catalog_carousel_show;

  const [recordingAudio, recordingAudioToggle] = useState(false);

  const [currentText, setCurrentText] = useState('');
  const [opennedChatId, setOpennedChatId] = useState('');
  const [currentQuickMessageId, setCurrentQuickMessageId] = useState(null);
  const [lastTimeout, setLastTimeout] = useState(0); //timeout para verificar se o usuario esta ou nao digitando
  const [sentMsg, setSentMsg] = useState(false);

  const [fontStylesSwitch, setFontStylesSwitch] = useState(false);

  const [isTemplateSelected, setIsTemplateSelected] = useState(false);
  const [isButtonsMessageSelected, setIsButtonsMessageSelected] =
    useState(false);
  const [isTemplateListSelected, setIsTemplateListSelected] = useState(false);
  const [isProcessingAudio, setIsProcessingAudio] = useState(false);

  const [showSchedulingForm, setShowSchedulingForm] = useState(false);
  const [step, setStep] = useState(0); // 0: Nenhuma etapa, 1: Seleção de data/hora, 2: Revisão
  const [scheduleData, setScheduleData] = useState({
    date: '',
    time: '',
  });
  const [messageScheduling, setMessageScheduling] = useState('');
  const [templateSelectedUuid, setTemplateSelectedUuid] = useState(null);

  const [channelId, setChannelId] = useState(
    opennedChat?.view?.selectedChannel?.id || opennedChat?.chat?.channel_id
  );

  const [previousText, setPreviousText] = useState('');
  const [isImproveAnswerSettingsOpen, setIsImproveAnswerSettingsOpen] =
    useState(false);

  const { sendTrigger, triggerTypes } = useTrigger();

  const {
    isOpen: copilotIsOpen,
    isLoading: copilotIsLoading,
    handleClose: handleCloseCopilotModal,
    input: copilotAnswer,
  } = useCopilotAnswer();

  const {
    isLoading: isLoadingImproveAnswer,
    handleOpen: handleOpenImproveAnswer,
    improveAnswerSettings,
    setImproveAnswerSettings,
    handleCreateImprovedAnswer,
  } = useImproveAnswer();

  const [isImprovedText, setIsImprovedText] = useState(false);
  const [isImprovedByAI, setIsImprovedByAI] = useState(false);

  const [isSuggestedText, setIsSuggestedText] = useState(false);
  const [isSuggestedByAI, setIsSuggestedByAI] = useState(false);
  const [isSuggestedByAIDiscarded, setIsSuggestedByAIDiscarded] =
    useState(false);

  const { scheduleMessageFlag } = useScheduleMessage();

  const channels = chat?.config?.general?.channels;
  const settings = chat?.config?.general?.settings;

  const canChat = canSendMessage();

  const showCatalog = chat?.catalog; // && chat?.config?.general?.settings?.catalog_service;
  const showCart = opennedChat?.cart_option_show;
  const isMessageBuilder =
    isTemplateSelected | isTemplateListSelected | isButtonsMessageSelected;

  const [urlPreview, setUrlPreview] = useState();
  const [mediaFormat, setMediaFormat] = useState();
  const [headerPreview, setHeaderPreview] = useState();
  const [bodyPreview, setBodyPreview] = useState();
  const [footerPreview, setFooterPreview] = useState();
  const [isReceptiveActive, setIsReceptiveActive] = useState(true);

  const [canOpenActiveChat, setCanOpenActiveChat] = useState(
    permissionsToOpenActiveChat(
      isReceptiveActive,
      hasRolePermissionToStartActiveChat,
      activeChatSetting
    )
  );

  const [blockSendMessageButton, setBlockSendMessageButton] = useState(
    validatePermissionToDisableSendMessageButton()
  );

  const [
    validationPermissionSendTextArea,
    setValidationPermissionSendTextArea,
  ] = useState(validationPermissionTextArea());

  // Traduções
  const searchEmojiText = useGlotaT('spa.chat.emoji.search');
  const clearText = useGlotaT('spa.chat.emoji.clear');
  const notFoundText = useGlotaT('spa.chat.emoji.notFound');
  const emojisFoundText = useGlotaT('spa.chat.emoji.emojisFound');
  const recentText = useGlotaT('spa.chat.emoji.recent');
  const smileysText = useGlotaT('spa.chat.emoji.smileys');
  const peopleText = useGlotaT('spa.chat.emoji.people');
  const natureText = useGlotaT('spa.chat.emoji.nature');
  const foodsText = useGlotaT('spa.chat.emoji.foods');
  const activityText = useGlotaT('spa.chat.emoji.activity');
  const placesText = useGlotaT('spa.chat.emoji.places');
  const objectsText = useGlotaT('spa.chat.emoji.objects');
  const symbolsText = useGlotaT('spa.chat.emoji.symbols');
  const flagsText = useGlotaT('spa.chat.emoji.flags');
  const customText = useGlotaT('spa.chat.emoji.custom');
  const boldText = useGlotaT('spa.chat.format.bold');
  const italicText = useGlotaT('spa.chat.format.italic');
  const strikethroughText = useGlotaT('spa.chat.format.strikethrough');
  const codeText = useGlotaT('spa.chat.format.code');
  const closeCatalogText = useGlotaT('spa.chat.catalog.closeCatalog');
  const catalogText = useGlotaT('spa.chat.catalog.catalog');
  const uploadFileText = useGlotaT('spa.chat.uploadFile');
  const noChannelCompatibleText = useGlotaT('spa.chat.noChannelCompatible');
  const sendTemplateOrQuickMessageText = useGlotaT(
    'spa.chat.sendTemplateOrQuickMessage'
  );
  const openEmojiPickerText = useGlotaT('spa.chat.openEmojiPicker');
  const closeEmojiPickerText = useGlotaT('spa.chat.closeEmojiPicker');

  // Traduções para novo contato e agendamento
  const newContactMessage = useGlotaT('spa.chat.newContact.message');
  const sendTemplateToStartConversation = useGlotaT(
    'spa.chat.newContact.sendTemplateToStartConversation'
  );
  const waitForMessageOrCreateTemplate = useGlotaT(
    'spa.chat.newContact.waitForMessageOrCreateTemplate'
  );
  const cannotScheduleForSelectedChannel = useGlotaT(
    'spa.chat.scheduling.cannotScheduleForSelectedChannel'
  );
  const channelNotSupportedForScheduling = useGlotaT(
    'spa.chat.scheduling.channelNotSupportedForScheduling'
  );
  const schedulingDateWithin24Hours = useGlotaT(
    'spa.chat.scheduling.dateWithin24Hours'
  );
  const cannotSendMessageText = useGlotaT('spa.chat.cannotSendMessage');
  const scheduleMessageTitleText = useGlotaT('spa.chat.scheduling.title');
  const selectMessageOrTemplateText = useGlotaT(
    'spa.chat.scheduling.selectMessageOrTemplate'
  );
  const messageScheduledText = useGlotaT(
    'spa.chat.scheduling.messageScheduled'
  );
  const atText = useGlotaT('spa.chat.scheduling.at');
  const errorSchedulingText = useGlotaT('spa.chat.scheduling.errorScheduling');

  const flags = useFlags([
    'new_channel_selector',
    'call_after_inactivity',
    'ia_improve_message',
  ]);
  const call_after_inactivity = customUseFlags(flags.call_after_inactivity);
  const ia_improve_message = customUseFlags(flags.ia_improve_message);

  useEffect(() => {
    if (isSuggestedByAI) {
      setIsImprovedByAI(false);
      setIsImprovedText(false);
    }
  }, [isSuggestedByAI]);

  useEffect(() => {
    if (isImprovedByAI) {
      setIsSuggestedText(false);
      setIsSuggestedByAI(false);
    }
  }, [isImprovedByAI]);

  useEffect(() => {
    if (clearChatTrigger) {
      updateText('');
      setClearChatTrigger(false);
    }
  }, [clearChatTrigger]);

  useEffect(() => {
    // sincroniza o valor guardado no context com o valor do state caso ele não tenha sido digitado pelo improveAnswer
    if (!isImprovedText) {
      setInputTextFromContext(currentText);
    }

    if (currentText.length <= MAX_TEXT_LENGTH_BEFORE_IMPROVE) {
      setIsImproveAnswerSettingsOpen(false);
    }
  }, [currentText]);

  const enabledActiveChatFlag = flags?.message_active?.enabled || false;
  const isWhiteLabel = useSelector(
    (state) => state?.whitelabel?.config?.is_white_label
  );

  const isWL = useWhiteLabel().isWl;

  const getUserRole = useSelector(
    (state) => state.chat?.config?.user?.superRole
  );

  const activeChatSetting = useSelector(
    /**
     * @param {*} state
     * @returns boolean
     * o valor de active na tabela settings
     * está no redux em state.chat?.config?.general?.settings?.active
     *
     * 0: desabilitado => operador e supervisor NÃO pode fazer chat ativo
     * 1: habilitado => operador e supervisor pode fazer chat ativo
     */
    (state) => state.chat?.config?.general?.settings?.active != 0
  );

  const hasRolePermissionToStartActiveChat = ['adm', 'manager'].includes(
    getUserRole
  );

  const showCustomBoxWL = useSelector((state) => {
    return (
      state?.whitelabel?.config?.script_injection &&
      state?.whitelabel?.config?.script_injection !== ''
    );
  });

  const { showQuickMessageSelectorV2 } = useQuickMessageSelectorFlag();
  const { findQuickMessageWithShortcut } = useGetQuickMessageFromShortcut();

  const receiveSelectedQuickMessage = useCallback(
    (quickMessage) => {
      updateText(
        quickMessage.text, //texto da mensagem
        quickMessage.id, // id da quick_quickMessage
        quickMessage.template && quickMessage.validated === 1, // é template válido,
        quickMessage.template_name?.includes('list'), // é mensagem tipo lista
        quickMessage.template_name?.includes('buttons') // é mensagem tipo buttons
      );
      closeQuickMessageSelectorAndClearSearchTerm();
    },
    [quickMessagesIsOpen]
  );

  useEffect(() => {
    if (currentText?.length > 2) {
      const _url = linkify(currentText);
      if (isJson(currentText)) {
        const _templateObj =
          _url &&
          (isTemplateSelected ||
            isTemplateListSelected ||
            isButtonsMessageSelected) &&
          JSON.parse(currentText);
        const _mediaFormat = _templateObj && _templateObj.header.mediaFormat;
        const _header = _templateObj && _templateObj.header.text;
        const _body = _templateObj && _templateObj.body;
        const _footer = _templateObj && _templateObj.footer;
        setUrlPreview(_url);
        setHeaderPreview(_header);
        setBodyPreview(_body);
        setFooterPreview(_footer);
        setMediaFormat(_mediaFormat);
      } else {
        setBodyPreview(currentText);
      }
    } else {
      setUrlPreview(undefined);
    }
  }, [currentText]);

  useEffect(() => {
    let chatChannelId = opennedChat?.view?.selectedChannel?.id;
    if (!chatChannelId) {
      chatChannelId = opennedChat?.chat?.channel_id;
    }
    if (chatChannelId && chatChannelId !== channelId) {
      setChannelId(chatChannelId);
    }
    setTemplateSelectedUuid(null);
    setMessageScheduling('');
  }, [
    currentQuickMessageId,
    opennedChat?.chat?.id,
    opennedChat?.view?.selectedChannel?.id,
    opennedChat?.chat?.channel_id,
    channelId,
  ]);

  // TODO: option usar o ApiList do src/enums/channels.js
  const channelApiTemplate = {
    waba: 33,
    BSP_Poli: 10,
    BSP_360: 34,
  };

  useEffect(() => {
    if (focusedTextArea === 'textbox') {
      setInsertTextHandler((emoji) => {
        setCurrentText((prev) => prev + emoji);
      });
    }
  }, [focusedTextArea]);

  /**
   * TODO: sugestão
   * mudar o nome da variavel
   * colocar essa variavel como useState
   * criar um useEffect para escutar o oppenedChat.api para setar o valor do estado
   * a função que avalia esse valor da api protegida por useCallback
   *  */
  const isTemplateApi =
    opennedChat?.view?.selectedChannel?.api === channelApiTemplate?.waba ||
    opennedChat?.view?.selectedChannel?.api === channelApiTemplate?.BSP_360 ||
    opennedChat?.view?.selectedChannel?.api === channelApiTemplate?.BSP_Poli;

  const [mediaLink, setMediaLink] = useState('');
  const [modalOpenPhoto, setModalOpenPhoto] = useState(false);

  useEffect(() => {
    if (urlPreview) {
      const _mediaLink = `${urlPreview}`?.split(',')[0]?.replace('"', '');
      setMediaLink(_mediaLink);
    }
  }, [urlPreview]);

  useEffect(() => {
    window.addEventListener('keydown', shortcutsForImproveAnswer, true);
    return () => {
      window.removeEventListener('keydown', shortcutsForImproveAnswer, true);
    };
  }, [previousText, isImprovedText, currentText]);

  // Shortcut Ctrl+Z para desfazer melhoria IA
  function shortcutsForImproveAnswer(e) {
    if (isImprovedText) {
      if (e.ctrlKey && e.key === 'z') {
        e.preventDefault();
        handleUndoImproveAnswer();
      }
    }

    if (e.ctrlKey && e.altKey && e.key === 'n') {
      if (currentText && currentText.length > 0) {
        e.preventDefault();
        handleImproveMessage();
      }
    }

    if (e.key === 'Tab') {
      e.preventDefault();

      if (showImproveAnswerButton() || isImprovedText) {
        setIsImproveAnswerSettingsOpen(true);
      }
    }
  }

  const handleUndoImproveAnswer = () => {
    let oldText = previousText;
    if (!isImprovedText) {
      oldText = currentText;
    }
    updateText(oldText);
    setIsImprovedText(false);
    toast.dismiss();
  };

  const handleImproveMessage = async () => {
    setIsImprovedByAI(true);

    const improveText = await handleCreateImprovedAnswer();

    if (!improveText) {
      toast.error('Error ao gerar sugestão de melhoria. Tente novamente.');
      return;
    }

    if (!isImprovedText) {
      setPreviousText(currentText);
    }

    setImproveAnswerSettings({
      ...improveAnswerSettings,
      context: [''],
    });

    setIsImprovedText(true);
    updateText(improveText);
  };

  const handleClickPreviewThumb = useCallback(() => {
    setModalOpenPhoto(!modalOpenPhoto);
  }, []);

  const linkify = useCallback((text) => {
    try {
      let urlRegex = /(https?:\/\/[^\s]+)/g;
      let urlWithProtocol = undefined;

      if (text?.includes('.')) {
        text
          .replace(urlRegex, function (url) {
            url = url.trim();
            urlWithProtocol = /(http|https|Http|Https|rtsp|Rtsp)/.test(url)
              ? url
              : 'http://' + url;
          })
          .trim();
      }

      const isUrl = new URL(urlWithProtocol);
      if (isUrl) {
        return urlWithProtocol;
      } else {
        return undefined;
      }
    } catch (error) {
      return undefined;
    }
  }, []);

  const {
    isUserAbleToSendMessage,
    data: balanceData,
    loading: isLoadingCustomerChannelContext,
  } = useContext(CustomerChannelBalanceContext);

  // Hook para verificar bloqueio de WABA em 100% de créditos
  const { shouldBlockMessage: shouldBlockWabaAt100 } = useWabaBlockAt100Credits(
    {
      channelId: opennedChat?.view?.selectedChannel?.id,
    }
  );

  // Atualiza o texto e atualiza o state algum momento depois
  const updateText = useCallback(
    (text, quick_message_id, isTemplate, isTemplateList, isButtonsMessage) => {
      setSentMsg(false);
      setCurrentText(text);
      setCurrentQuickMessageId(quick_message_id);
      checkTyping(text);
      setIsTemplateSelected(isTemplate);
      setIsTemplateListSelected(isTemplateList);
      setIsButtonsMessageSelected(isButtonsMessage);
    },
    []
  );

  const setFocusOnInputText = useCallback((e) => {
    if (!isMobile && document.getElementById('textAreaMessage')) {
      if (chatOwner && currentUser) {
        if (chatOwner === currentUser.id) {
          document.getElementById('textAreaMessage').focus();
        }
      }
    }
  }, []);

  useEffect(() => {
    if (opennedChat?.chat?.id) {
      getProtocol(opennedChat?.id);
      setFocusOnInputText();
      // Usado para saber o Id do Chat Atual
      setOpennedChatId(opennedChat?.chat?.id);

      // Corrigindo o bug catalogo ficar aberto em outro chat ou some caixa de texto se catalogo do chat anterior tiver aberto
      if (showCatalog && showCatalogCarousel) {
        handleOpenCatalog();
      } else {
        handleCloseCatalog();
      }
    }
  }, [opennedChatId]);

  useEffect(() => {
    <CartPanel blockInteraction={blockInteraction} />;
  }, [showCart]);

  useEffect(() => {
    if (opennedChat.replying_message) setFocusOnInputText();
  }, [opennedChat.replying_message]);

  /**
   * Logica de Janela 24 horas do facebook
   */
  const [alert_timer_to_finish, setAlertTimerToFinish] = useState('');
  useEffect(() => {
    const selectedChannelType = opennedChat?.view?.selectedChannel?.type;
    const selectedChannelId = opennedChat?.view?.selectedChannel?.id ?? '';

    if (['facebook', 'instagram', 'waba'].includes(selectedChannelType)) {
      const check = () => {
        if (opennedChat.loadMessages) {
          // Pegando ultima mensagem do canal selecionado
          const _lastReceivedMsg =
            opennedChat?.last_message_received[selectedChannelType];

          // Se for waba pegar ultima mensagem do channel_id selecionado
          const lastReceivedMessage =
            selectedChannelType === 'waba' && _lastReceivedMsg
              ? _lastReceivedMsg[selectedChannelId]
              : _lastReceivedMsg;

          let is_active = true;
          const exist_template =
            opennedChat?.view?.selectedChannel?.type !== 'facebook';

          if (!lastReceivedMessage) {
            is_active = false;
            if (exist_template && !chat?.quickMessages?.isOpen) {
              toggleQuickMessagesSelector();
            }

            setBlockInteraction(true);
            setAlertTimerToFinish(
              <Alert color="danger" className="alert-timer-to-finish">
                <Icon icon="poli-icon pi-alert-fill" /> {newContactMessage}
                {exist_template
                  ? ` ${sendTemplateToStartConversation}`
                  : ` ${waitForMessageOrCreateTemplate}`}
              </Alert>
            );
            setIsWindow24Open(true);
            setCurrentText('');
            return;
          } else {
            if (lastReceivedMessage?.channel_id == selectedChannelId) {
              if (
                balanceData?.contact?.use_conversation_window === true &&
                balanceData?.contact?.has_open_window === true
              ) {
                is_active = true;
              } else {
                const lastReceivedMessageDate = parseInt(
                  lastReceivedMessage.dtm
                );
                const nowInSeconds = Math.floor(Date.now() / 1000);
                is_active =
                  nowInSeconds - lastReceivedMessageDate <= 86400 - 30; ///30 é margem de segurança
              }
            } else {
              is_active = false;
            }
          }

          if (is_active) {
            if (isSuspended) {
              setBlockInteraction(true);
            } else {
              setBlockInteraction(false);
            }
            setAlertTimerToFinish('');
            setIsWindow24Open(false);
            if (selectedChannelType !== 'waba' && quickMessagesIsOpen) {
              // fix bug where quickMessages was being closing on WABA.
              toggleQuickMessagesSelector();
            }
          } else {
            const isInstagram = selectedChannelType === 'instagram';
            if (!isInstagram && exist_template && !chat.quickMessages?.isOpen) {
              toggleQuickMessagesSelector();
            }

            const templateMessage = exist_template
              ? ' envie um dos seus templates para voltar a conversar com este contato'
              : ' aguarde seu contato voltar a conversar';
            const message = isInstagram
              ? 'Este contato está há mais de 24h sem interagir com o canal'
              : `O período de 24 horas para manter uma conversa expirou, ${templateMessage}`;

            setBlockInteraction(true);
            setAlertTimerToFinish(
              <Alert color="danger" className="alert-timer-to-finish">
                <Icon icon="poli-icon pi-alert-fill" />
                {message}
              </Alert>
            );
            setIsWindow24Open(true);
            setCurrentText('');
            setIsTemplateSelected('');
          }
        }
      };

      check();
    } else {
      if (alert_timer_to_finish !== '' && chat.quickMessages?.isOpen) {
        toggleQuickMessagesSelector();
      }
      if (isSuspended) {
        setBlockInteraction(true);
      } else {
        setBlockInteraction(false);
      }

      setAlertTimerToFinish('');
      setIsWindow24Open(false);
    }
  }, [
    opennedChat?.view?.selectedChannel,
    opennedChatId,
    opennedChat?.messages,
    opennedChat?.last_message,
    canOpenActiveChat,
    hasRolePermissionToStartActiveChat,
    activeChatSetting,
    isZapiOrWebchat,
    balanceData,
  ]);

  useEffect(() => {
    if (isSuspended) {
      setBlockInteraction(isSuspended);
    }
  }, [opennedChat?.chat?.id, isSuspended]);

  // Disable/enable textArea and buttonSendMessage.
  useEffect(() => {
    setValidationPermissionSendTextArea(!!validationPermissionTextArea());
    setBlockSendMessageButton(!!validatePermissionToDisableSendMessageButton());

    setIsZapiOrWebchat(
      !['facebook', 'instagram', 'waba'].includes(
        opennedChat?.view?.selectedChannel?.type
      )
    );

    setCanOpenActiveChat(
      permissionsToOpenActiveChat(
        isReceptiveActive,
        hasRolePermissionToStartActiveChat,
        activeChatSetting
      )
    );
  }, [
    opennedChat?.chat?.id,
    canChat,
    isUserAbleToSendMessage,
    alert_timer_to_finish,
    opennedChat?.loadMessages,
    opennedChat?.view?.selectedChannel,
    isTemplateListSelected,
    isButtonsMessageSelected,
    isTemplateApi,
    isTemplateSelected,
    enabledActiveChatFlag,
    canOpenActiveChat,
    isReceptiveActive,
    hasRolePermissionToStartActiveChat,
    activeChatSetting,
    isLoadingImproveAnswer,
  ]);
  const isZapi = !['facebook', 'instagram', 'waba', 'webchat'].includes(
    opennedChat?.view?.selectedChannel?.type
  );

  function handleCloseImproveAnswerSettings() {
    setIsImproveAnswerSettingsOpen(false);
  }

  function handleOpenImproveAnswerSettings() {
    setIsImproveAnswerSettingsOpen(false);
  }

  function handleToggleImproveAnswerSettings() {
    setIsImproveAnswerSettingsOpen(!isImproveAnswerSettingsOpen);
  }

  /* End -> Janela 24 Horas */
  // Verifica se o usuário tem permissão para abrir o chat ativo fora da janela de 24h.
  function permissionsToOpenActiveChat(
    isReceptiveActive,
    activeChatSetting,
    isAdminOrManager
  ) {
    // Returns default true if flag disabled to prevent invalid block.
    return enabledActiveChatFlag
      ? isAdminOrManager || isReceptiveActive || activeChatSetting
      : true;
  }

  // Usado para saber se o Chat Atual é o mesmo do anterior
  if (opennedChatId != opennedChat?.chat?.id) {
    setIsTemplateSelected(false);
    setCurrentText('');
    setOpennedChatId(opennedChat?.chat?.id);
    setIsReceptiveActive(true);
  }

  if (!canChat) {
    return (
      <Alert
        color="warning"
        style={{ margin: 0, justifyContent: 'center' }}
        fade={false}
      >
        <Icon icon="poli-icon pi-alert-fill" color="warning" size="45px" />
        <span>{noChannelCompatibleText}</span>
      </Alert>
    );
  }
  let emojiTheme = 'light';
  let emojiPicker;

  if (localStorage.getItem('@polichat/darkmode') === 'true') {
    emojiTheme = 'dark';
  }

  if (emojiPickerState) {
    emojiPicker = (
      <Picker
        set="apple"
        theme={emojiTheme}
        title=""
        emoji="point_up"
        onSelect={(emoji) => insertText(emoji.native)}
        style={{
          width: '100%',
          borderBottom: 'none',
        }}
        i18n={{
          search: searchEmojiText,
          clear: clearText,
          notfound: notFoundText,
          categories: {
            search: emojisFoundText,
            recent: recentText,
            smileys: smileysText,
            people: peopleText,
            nature: natureText,
            foods: foodsText,
            activity: activityText,
            places: placesText,
            objects: objectsText,
            symbols: symbolsText,
            flags: flagsText,
            custom: customText,
          },
        }}
        showCloseButton={true}
      />
    );
  }

  function triggerPicker(event) {
    event.preventDefault();

    if (quickMessagesIsOpen) {
      toggleQuickMessagesSelector();
    }
    setEmojiPicker(!emojiPickerState); //emoji true
    closeCatalogCarousel();
  }

  function handleOpenCatalog() {
    if (emojiPickerState) {
      setEmojiPicker(false);
    }

    if (quickMessagesIsOpen) {
      toggleQuickMessagesSelector();
    }

    // if (document.querySelector('.textBoxContainer')) {
    //   document.querySelector('.textBoxContainer')?.classList.add('hidden');
    // }

    // if (document.querySelector('.contactExternalContainer')) {
    //   document
    //     .querySelector('.contactExternalContainer')
    //     ?.classList.add('hidden');
    // }

    // document.querySelector('.buttonUploadFiles')?.classList.add('hidden');
    // document
    //   .querySelector('#buttonHandleQuickMessages')
    //   ?.classList.add('hidden');

    // document.querySelector('.buttonHandleEmoji')?.classList.add('hidden');
    // document.querySelector('.buttonHandleAudio')?.classList.add('hidden');
    // document.querySelector('#sendMessageButton')?.classList.add('hidden');
    // document.querySelector('.groupActionsLeft')?.classList.add('hidden');

    if (isMobile) {
      document.querySelector('.cartPanel')?.classList?.add('hidden');
    }
    openCatalogCarousel();
  }

  function handleCloseCatalog() {
    closeCatalogCarousel();
  }

  function closePickerEmoji(event) {
    event.preventDefault();
    setEmojiPicker(false);
    closeCatalogCarousel();
  }

  function handleStyleBold(text) {
    if (text === '') {
      return null;
    }
    let textMessage = String(
      document.querySelector('#textAreaMessage').value.trimEnd()
    );
    let newText = textMessage.split(text).join(`*${text}*`);
    return setCurrentText(newText);
  }

  function handleStyleItalic(text) {
    if (text === '') {
      return null;
    }
    let textMessage = document
      .querySelector('#textAreaMessage')
      .value.trimEnd();
    let newText = textMessage.split(text).join(`_${text}_`);
    return setCurrentText(newText);
  }

  function handleStyleStrike(text) {
    if (text === '') {
      return null;
    }
    let textMessage = document
      .querySelector('#textAreaMessage')
      .value.trimEnd();
    let newText = textMessage.split(text).join(`~${text}~`);
    return setCurrentText(newText);
  }

  function handleStyleCode(text) {
    if (text === '') {
      return null;
    }
    let textMessage = document
      .querySelector('#textAreaMessage')
      .value.trimEnd();

    let newText = textMessage.split(text).join('```' + text + '```');
    return setCurrentText(newText);
  }

  function isValidJson(isObject) {
    try {
      const valid = typeof isObject === 'object' ? true : false;
      return valid;
    } catch {
      return false;
    }
  }

  // Verifica as hotkeys ou shift + enter
  function handleKeyPressEvent(event) {
    if (event.nativeEvent.keyCode === 13) {
      if (quickMessagesIsOpen) {
        setEmojiPicker(false);
        toggleQuickMessagesSelector();

        let messages = chat.quickMessages.search;
        if (!messages) {
          messages = chat.quickMessages.messages;
        }
        let nav = chat.quickMessages.nav || 0;
        if (nav > messages.length) {
          nav = messages.length - 1;
        }
        if (messages && messages.length >= nav && messages[nav]) {
          if (isValidJson(nav ? messages[nav] : messages[0])) {
            const navOrZero = nav ? nav : 0;
            if (!QuickMessages.selectTable(messages[navOrZero], opennedChat)) {
              return;
            }
            QuickMessages.setMessage(messages[navOrZero]);
            let textMessage = QuickMessages.updateText(
              currentText,
              opennedChat,
              true
            );
            updateText(
              textMessage,
              messages[navOrZero].id,
              (messages[navOrZero].template &&
                messages[navOrZero].validated === 1) ||
                messages[navOrZero].template_name?.indexOf(
                  `messages[${navOrZero}]`
                ) > -1,
              messages[navOrZero].template_name?.indexOf(
                `messages[${navOrZero}]`
              ) > -1
            );
          } else {
            let textMessage = QuickMessages.updateText(
              currentText,
              opennedChat
            );
            updateText(textMessage);
          }
          event.nativeEvent.stopPropagation();
          event.nativeEvent.preventDefault();
          return false;
        }
      } else {
        if (isSuspended) return;
        return handleSubmitTextEvent(event);
      }
    } else if (
      event.nativeEvent.keyCode === 35 &&
      !quickMessagesIsOpen &&
      chat.quickMessages.messages &&
      chat.quickMessages.messages.length
    ) {
      setEmojiPicker(false);
      toggleQuickMessagesSelector();
    } else if (quickMessagesIsOpen) {
      let selectionStart =
        document.querySelector('#textAreaMessage').selectionStart;
      let term = '';
      if (selectionStart > 0) {
        let text = currentText;
        for (let i = text.length; i > 0; i--) {
          if (text.substr(i - 1, 1) === '#') {
            term = text.substr(i, selectionStart) + event.nativeEvent.key;
          }
        }
      }
      searchQuickMessages(term);
    }
  }

  // Essa função separada do handleKeyDown é necessária para o correto funcionamento
  // no android
  function handleInputEvent(event) {
    // Funcionar as pesquisas das mensagens rapidas no android
    if (isMobile) {
      const _txt = event.target.value;
      updateText(_txt);

      let selectionStart =
        document.querySelector('#textAreaMessage')?.selectionStart;
      let term = '';
      if (selectionStart > 0) {
        for (let i = _txt.length; i > 0; i--) {
          if (_txt.substr(i - 1, 1) === '#') {
            term = _txt.substr(i, selectionStart - 1);
          }
        }
      }
      searchQuickMessages(term);
    }
    /* end */

    let text = event.nativeEvent.data;
    if (text) {
      // Abre o painel de quick messages quando o usuário digita '#'
      if (text.slice(-1) === '#' && !quickMessagesIsOpen) {
        setEmojiPicker(false);
        toggleQuickMessagesSelector();
      } else if (text.slice(-1) === ' ' && quickMessagesIsOpen) {
        setEmojiPicker(false);
        toggleQuickMessagesSelector();
      }
    }
  }

  function handleKeyDownEvent(event) {
    QuickMessages.onKeyDownEvent(event);
    if (QuickMessages.existMessage()) {
      let textMessage = QuickMessages.updateText(currentText, opennedChat);
      return updateText(textMessage);
    } else if (
      (event.nativeEvent.keyCode === 32 || event.nativeEvent.keyCode === 27) &&
      quickMessagesIsOpen
    ) {
      setEmojiPicker(false);
      toggleQuickMessagesSelector();
    } else if (event.nativeEvent.keyCode === 8 && quickMessagesIsOpen) {
      const text = currentText;
      const selectionStart =
        document.querySelector('#textAreaMessage').selectionStart;
      let term = '';
      for (let i = text.length; i > 0; i--) {
        if (text.substr(i - 1, 1) === '#') {
          term = text.substr(i, selectionStart - 2);
        }
      }
      searchQuickMessages(term);
    } else if (
      (event.nativeEvent.keyCode === 38 || event.nativeEvent.keyCode === 40) &&
      quickMessagesIsOpen
    ) {
      navQuickMessagesSelector(
        event.nativeEvent.keyCode === 38 ? 'up' : 'down'
      );
      event.nativeEvent.stopPropagation();
      event.nativeEvent.preventDefault();
    }
  }

  function closeQuickMessageSelectorAndClearSearchTerm() {
    searchQuickMessages('', showQuickMessageSelectorV2);

    if (quickMessagesIsOpen) {
      toggleQuickMessagesSelector();
    }

    setFocusOnInputText();
  }

  function handleKeyEventsV2(event) {
    // se seletor está fechado aperta enter deve enviar a mensagem
    if (event.key === KeyboardCodes.ENTER && !quickMessagesIsOpen) {
      if (isSuspended) return;
      return handleSubmitTextEvent(event);
    }

    if (event.key === KeyboardCodes.ESCAPE && quickMessagesIsOpen) {
      closeQuickMessageSelectorAndClearSearchTerm();
    }

    // Lida com os atalhos das mensagens rápidas
    // Detecta se o Ctrl for pressionado COM outra telca (i.e.: ignora só o control sozinho)
    if (event.ctrlKey && event.key !== KeyboardCodes.CONTROL) {
      let result = findQuickMessageWithShortcut(event.key);

      if (result) {
        receiveSelectedQuickMessage(result);
      }
    }
  }

  function wrapperKeyPressEvent(event) {
    if (!showQuickMessageSelectorV2) {
      handleKeyPressEvent(event);
    }
  }

  function wrapperKeyDownEvent(event) {
    if (!showQuickMessageSelectorV2) {
      handleKeyDownEvent(event);
      return;
    }
    handleKeyEventsV2(event);
  }

  function wrapperInputEvent(event) {
    setIsImprovedText(false);

    if (!showQuickMessageSelectorV2) {
      handleInputEvent(event);
      return;
    }
    // Abrir o quick message selector o primeiro item digitado é #
    if (
      event.target.value.length === 1 &&
      event.nativeEvent.data === KeyboardCodes.HASH_TAG &&
      !quickMessagesIsOpen
    ) {
      toggleQuickMessagesSelector();
    }

    // Se houver texto apos # realizar a busca do Quick Message Selector
    if (
      quickMessagesIsOpen &&
      event.target.value[0] === KeyboardCodes.HASH_TAG
    ) {
      // Se o ultimo caractere for espaço deve fechar o seletor
      if (event.target.value[event.target.value.length - 1] === ' ') {
        closeQuickMessageSelectorAndClearSearchTerm();
        return;
      }
      // o parametro showQuickMessageSelector é utilizado para passar a flag ao reducer e evitar calculo
      searchQuickMessages(
        event.target.value.substr(1),
        showQuickMessageSelectorV2
      );
    }
  }

  // Submete o texto
  function handleSubmitTextEvent(event) {
    if (event.nativeEvent.shiftKey) {
      return;
    } else {
      event.preventDefault();
      event.stopPropagation();

      if (currentText) {
        setSentMsg(true);
        setCurrentText(''); // zera o texto atual
        checkTyping(null); // Forçando limpar o texto
        clearTimeout(lastTimeout); //evita enviar o texto antigo para o state novamente
        updateMessageTextArea(opennedChat.id, null); //envia o texto para o state
        sendMessageEvent(); //evento de enviar mensagem
      }
    }
  }

  // Verifica se o usuario parou de digitar e armazena o texto dele no state
  function checkTyping(text) {
    clearTimeout(lastTimeout);
    setLastTimeout(
      setTimeout(
        () => {
          updateMessageTextArea(opennedChat.id, sentMsg ? '' : text);
        },
        isMobile ? 0 : 1000
      )
    );
  }

  function findChannelId() {
    if (opennedChat?.view && opennedChat?.view?.selectedChannel) {
      return opennedChat.view.selectedChannel.id;
    }
    return null;
  }

  function sendCopilotTriggers() {
    if (!opennedChat?.id) return;

    let element = null;

    // mensagem sugerida pela IA e descartada pelo usuário
    if (isSuggestedByAIDiscarded) {
      element = 'submitted-copilot-suggestion-discarded-by-user';
    }

    // mensagem sugerida pela IA sem edição do usuário
    else if (isSuggestedByAI && isSuggestedText) {
      element = 'submitted-copilot-suggestion';
    }

    // mensagem sugerida pela IA com edição do usuário
    else if (isSuggestedByAI && !isSuggestedText) {
      element = 'submitted-copilot-suggestion-edited-by-user';
    }

    if (element) {
      sendTrigger({
        entity_id: opennedChat?.id,
        entity_type: 'contact',
        type: triggerTypes.SUBMITTED,
        origin: 'antiga-interface',
        payload: {
          component: 'TextBox',
          hook: null,
          element: element,
        },
      });
    }
  }

  // Envia a mensagem pro back via websocket
  function sendMessageEvent() {
    if (blockSendMessageButton || isSuspended || shouldBlockWabaAt100) return;

    if (canSendMessage() && isUserAbleToSendMessage && !shouldBlockWabaAt100) {
      const has_message =
        (currentText && currentText.length > 0) ||
        (copilotAnswer && copilotIsOpen && !copilotIsLoading);

      if (has_message) {
        const new_message =
          currentText && currentText.length > 0 ? currentText : copilotAnswer;

        let message_type = 'chat';

        if (isImprovedByAI) {
          message_type = 'improved_message';
        } else if (isSuggestedByAI) {
          message_type = 'suggestion';
        }

        let message_data = mountMessage(opennedChat, new_message, message_type);

        let data_send = {
          chat_id: opennedChat?.id,
          channel_id: findChannelId(),
          user_id: chat.config?.user?.id,
          contact_id: opennedChat?.contact?.id,
          external_id: findSelectedExternalId(),
          message_body: new_message,
          cuid: message_data.cuid,
          type: message_data.type,
        };

        if (opennedChat.replying_message) {
          message_data.reply_message = opennedChat.replying_message;
          data_send.reply_message_uid =
            opennedChat.replying_message && opennedChat.replying_message.uid
              ? opennedChat.replying_message.uid
              : null;
        }
        if (currentQuickMessageId > 0) {
          try {
            const canSendQuickMessage = validQuickMessageVariables(new_message);
            if (!canSendQuickMessage) {
              return;
            }
          } catch (e) {}

          data_send.quick_message_id = currentQuickMessageId;
        }

        sendCopilotTriggers();

        clearReplyingMessage({ chat_id: opennedChat.id });

        setIsSuggestedText(false);
        setIsSuggestedByAI(false);
        setIsSuggestedByAIDiscarded(false);
        setIsImprovedText(false);
        setIsImprovedByAI(false);
        addMessage(message_data);
        sendMessage(data_send);
        updateMessageTextArea(opennedChat.id, null);
        setCurrentText('');
        setCurrentQuickMessageId(null);
        setIsTemplateListSelected(false);
        setIsButtonsMessageSelected(false);
        setIsTemplateSelected(false);
        handleCloseCopilotModal();
      }
    } else {
      toast.warning(cannotSendMessageText);
    }
  }

  function validQuickMessageVariables(quickMessageText) {
    let messageType = 'Mensagem rápida';

    // Trycatch para evitar erro no JSON.parse se for mensagem rápida (not-json).
    try {
      let templatePayload = JSON.parse(quickMessageText) || undefined;

      if (templatePayload && templatePayload.name) {
        if (templatePayload.name.includes('polichat_list_message_')) {
          messageType = 'Lista';
        }

        if (templatePayload.name.includes('polichat_buttons_message_')) {
          messageType = 'Botões interativos';
        }

        if (templatePayload.name.includes('polichat_quick_message_')) {
          messageType = 'Template';
        }
      }
    } catch (e) {}

    // TODO validar as outras variáveis, escrever as mensagens e revisar com o GH.

    if (quickMessageText.includes('[contact_name]')) {
      toast.error(
        `Erro ao enviar ${messageType}. \n A variável contact_name não foi preenchida pois o nome do contato não foi registrado.`
      );
      return false;
    }

    if (quickMessageText.includes('[contact_first_name]')) {
      toast.error(
        `Erro ao enviar ${messageType}. \n A variável contact_first_name não foi preenchida pois o nome do contato não foi registrado.`
      );
      return false;
    }

    if (quickMessageText.includes('[contact_email]')) {
      toast.error(
        `Erro ao enviar ${messageType}. \n A variável contact_email não foi preenchida pois o email do contato não foi registrado.`
      );
      return false;
    }

    return true;
  }

  function canSendMessage() {
    const result = !!(
      opennedChat &&
      opennedChat.chat &&
      opennedChat.view &&
      opennedChat.view.selectedChannel &&
      opennedChat.contact &&
      channels.length
    );

    return result;
  }

  function findSelectedExternalId() {
    const selectedChannel = opennedChat?.view?.selectedChannel;
    const externals = opennedChat?.contact?.externals || [];

    if (!selectedChannel) return null;

    if (selectedChannel.type === 'waba') {
      const wabaExternal = externals.find(
        (external) => external.channel_id === 6 && external.uid
      );

      return wabaExternal?.id ?? null;
    }

    const selected = externals.find((external) => external.selected === true);
    return selected?.id ?? null;
  }

  async function onSendAudioBase64(base64, blob) {
    setIsProcessingAudio(true);

    function treatMountedMessageToNanoAudioUpload(mountedMessage) {
      let nanoaudioMessage = {
        message_cuid: `nanoaudio-v2-${mountedMessage.cuid}`,
        type: mountedMessage.type,
        send_type: 'media',
        user_id: chat.config.user.id,
        customer_id: chat.config.user.current_customer_id,
        customer_channel: mountedMessage.channel_id,
        channel_id: mountedMessage.channel_id,
        contact_id: mountedMessage.contact_id,
        external_id: findSelectedExternalId() || 0,
        url: mountedMessage.message_body.url,
        reply_message_uid:
          mountedMessage.reply_message && mountedMessage.reply_message.uid
            ? mountedMessage.reply_message.uid
            : undefined,
      };

      return nanoaudioMessage;
    }

    try {
      let audioMessage = mountMessage(opennedChat, base64, 'ptt');

      if (opennedChat.replying_message) {
        audioMessage.reply_message = opennedChat.replying_message;
      }

      let audioMessageToNanoAudio =
        treatMountedMessageToNanoAudioUpload(audioMessage);

      const formData = new FormData();
      formData.append('file', blob);
      formData.append('data', JSON.stringify(audioMessageToNanoAudio));

      await poliApiGatewayRequest
        .post('/nanoaudio/upload', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(function (response) {
          clearReplyingMessage({ chat_id: opennedChat.id });
          addMessage({
            ...audioMessage,
            cuid: audioMessageToNanoAudio.message_cuid,
          });
        })
        .catch(function (err) {
          throw err;
        });
    } catch (error) {
      if (error.code === 'ERR_NETWORK') {
        Sentry.captureMessage(`Erro de CORS ao enviar audio.`);
        Sentry.captureException(error);
      }

      toast.error('Ocorreu um erro no envio da mensagem de audio');
    } finally {
      setIsProcessingAudio(false);
    }
  }

  function showImproveAnswerButton() {
    const hasMoreThanThreeChars =
      currentText && currentText.length > MAX_TEXT_LENGTH_BEFORE_IMPROVE;

    return canImproveAnswer() && hasMoreThanThreeChars && !isImprovedText;
  }

  function canImproveAnswer() {
    return (
      !validationPermissionSendTextArea &&
      !recordingAudio &&
      canOpenActiveChat &&
      !blockSendMessageButton &&
      currentText &&
      currentText.length &&
      ia_improve_message
    );
  }

  function validationPermissionTextArea() {
    if (enabledActiveChatFlag) {
      return (
        !canOpenActiveChat ||
        !canChat ||
        alert_timer_to_finish !== '' ||
        !opennedChat?.loadMessages ||
        !isUserAbleToSendMessage ||
        isTemplateSelected ||
        isTemplateListSelected ||
        isButtonsMessageSelected ||
        isLoadingImproveAnswer ||
        (!isTemplateApi && isTemplateSelected)
      );
    }
    return (
      !canChat ||
      alert_timer_to_finish !== '' ||
      !opennedChat?.loadMessages ||
      !isUserAbleToSendMessage ||
      isTemplateSelected ||
      isTemplateListSelected ||
      isButtonsMessageSelected ||
      isLoadingImproveAnswer ||
      (!isTemplateApi && isTemplateSelected)
    );
  }

  function validatePermissionToDisableSendMessageButton() {
    if (enabledActiveChatFlag) {
      return (
        !canOpenActiveChat ||
        !canChat ||
        !isUserAbleToSendMessage ||
        (!isTemplateApi && isTemplateSelected)
      );
    }

    return (
      !canChat ||
      !isUserAbleToSendMessage ||
      (!isTemplateApi && isTemplateSelected)
    );
  }

  function getCurrentText() {
    if (isLoadingImproveAnswer) {
      return 'Gerando resposta aprimorada... Aguarde.';
    }

    if (
      isTemplateSelected ||
      isTemplateListSelected ||
      isButtonsMessageSelected
    ) {
      // extract from JSON of quick_message.text
      return getMessageBuilderTemplateText(currentText);
    }

    return currentText;
  }

  const checkScheduleWindow = (scheduleDate, scheduleTime) => {
    if (!opennedChat.loadMessages) return false;
    const selectedChannelType = opennedChat?.view?.selectedChannel?.type;
    const _lastReceivedMsg =
      opennedChat?.last_message_received[selectedChannelType];
    const lastReceivedMessage =
      selectedChannelType === 'waba' && _lastReceivedMsg
        ? _lastReceivedMsg[opennedChat?.view?.selectedChannel?.id]
        : _lastReceivedMsg;

    if (!lastReceivedMessage) return false;

    const lastReceivedMessageDate = parseInt(lastReceivedMessage.dtm);

    const [scheduleYear, scheduleMonth, scheduleDay] = scheduleDate
      .split('-')
      .map(Number);
    const [scheduleHour, scheduleMinute] = scheduleTime.split(':').map(Number);

    const scheduleDateTime =
      new Date(
        scheduleYear,
        scheduleMonth - 1,
        scheduleDay,
        scheduleHour,
        scheduleMinute
      ).getTime() / 1000;
    // Verifica se a data de agendamento está dentro da janela de 24 horas da última mensagem
    const isWithin24Hours = scheduleDateTime - lastReceivedMessageDate <= 86400;

    return isWithin24Hours;
  };

  const channelType = opennedChat?.view?.selectedChannel?.type;

  // Função para alternar a exibição do formulário de agendamento
  const toggleSchedulingForm = () => {
    if (isSuspended) return;
    if (['whatsapp', 'instagram', 'waba'].includes(channelType) || isZapi) {
      setShowSchedulingForm(!showSchedulingForm);
    } else if (['messenger', 'webchat'].includes(channelType)) {
      toast.warning(cannotScheduleForSelectedChannel);
    } else {
      toast(channelNotSupportedForScheduling);
    }
    if (!showSchedulingForm) {
      setStep(1); // Inicia na etapa de seleção de data/hora
    }
  };

  const nextStep = () => {
    const { date, time } = scheduleData;

    const isWithin24Hours = checkScheduleWindow(date, time);

    // Se não for uma mensagem template e não estiver dentro da janela de 24 horas
    if (
      !isZapi &&
      !currentQuickMessageId &&
      !isWithin24Hours &&
      !isTemplateApi
    ) {
      toast.error(schedulingDateWithin24Hours);
      return;
    }

    setStep(step + 1);
  };

  // Função para voltar para a etapa anterior
  const prevStep = () => {
    setStep(step - 1);
  };

  // Função para gerenciar mudanças na data e hora
  const handleScheduleChange = (e) => {
    const { name, value } = e.target;

    setScheduleData({
      ...scheduleData,
      [name]: value,
    });
  };

  const cancelScheduling = () => {
    setShowSchedulingForm(false);
    setStep(0);
    setScheduleData({ date: '', time: '' });
  };

  const handleScheduleSubmit = async () => {
    let customField = 'send_text';
    if (currentQuickMessageId) {
      customField = 'send_template';
    }
    const { date, time } = scheduleData;

    const messageData = {
      user_uuid: currentUser.uuid,
      account_uuid: currentUser.active_account_uuid,
      contact_uuids: [
        opennedChat?.contact?.contact_uuid ?? opennedChat?.contact?.uuid,
      ],
      channel_uuid: opennedChat?.view?.selectedChannel?.id,
      message_type: templateSelectedUuid ? 'template' : 'text',
      message_content: [
        {
          ...(templateSelectedUuid && { template_uuid: templateSelectedUuid }),
          text: messageScheduling,
          provider: opennedChat?.view?.selectedChannel?.type.toUpperCase(),
        },
      ],
      schedule_day: date,
      schedule_time: time,
    };

    if (currentQuickMessageId) {
      messageData.template_id = currentQuickMessageId;
    }
    try {
      await scheduleMessage(
        currentUser.active_account_uuid,
        currentUser.uuid,
        messageData
      );
      setMessageScheduling('');
      setScheduleData({ date: '', time: '' });
      const formattedDate = date.split('-').reverse().join('/');
      toast.success(
        `${messageScheduledText} ${formattedDate} ${atText} ${scheduleData.time} `
      );
      setStep(0);
    } catch (error) {
      toast.error(error?.response?.data?.message ?? errorSchedulingText);
    }
  };

  return (
    <>
      <Modal
        isOpen={modalOpenPhoto}
        toggle={() => {
          handleClickPreviewThumb;
        }}
        className={'modalLightBox'}
      >
        <ModalHeader
          toggle={() => {
            handleClickPreviewThumb;
          }}
        >
          <div className="btnActionLightBox">
            <span
              onClick={() => {
                setModalOpenPhoto(false);
                window.open(mediaLink);
              }}
              style={{ cursor: 'pointer', marginRight: '10px' }}
            >
              <Icon icon="poli-icon pi-download-line" size={24} color="#fff" />
            </span>
            <span
              onClick={() => {
                setModalOpenPhoto(false);
              }}
            >
              <Icon icon="poli-icon pi-close-line" size={24} color="#fff" />
            </span>
          </div>
        </ModalHeader>
        <ModalBody>
          {mediaFormat === 'IMAGE' ? (
            <img
              src={mediaLink}
              style={{
                maxWidth: '100%',
                maxHeight: '100%',
                margin: 0,
                padding: 0,
                borderRadius: 0,
              }}
            />
          ) : mediaFormat === 'VIDEO' ? (
            <div
              style={{
                maxWidth: '100%',
                maxHeight: '100%',
                margin: 0,
                padding: 0,
                borderRadius: 0,
              }}
            >
              <video controls>
                <source src={mediaLink} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          ) : (
            ''
          )}
        </ModalBody>
      </Modal>

      {alert_timer_to_finish}
      {isProcessingAudio && (
        <Alert
          color="warning"
          className="alert-timer-to-finish alert-timer-audio"
        >
          <Icon icon="poli-icon pi-alert-fill" /> Aguarde o processamento do
          áudio
        </Alert>
      )}
      {shouldBlockWabaAt100 && (
        <Alert
          color="danger"
          className="alert-timer-to-finish alert-waba-blocked"
        >
          <Icon icon="poli-icon pi-alert-fill" /> Envio de mensagens bloqueado:
          o canal WABA atingiu 100% dos créditos contratados. Entre em contato
          com o financeiro.
        </Alert>
      )}
      {(isWL || isMobile) && (
        <ChannelCreditsAlert
          channelId={Number(opennedChat?.view?.selectedChannel?.id)}
        />
      )}
      {emojiPicker && <div className="emojiContainer">{emojiPicker}</div>}
      {call_after_inactivity && <CallAfterInactivity />}
      {showQuickMessageSelectorV2 ? (
        <QuickMessageSelectorV2
          showOnlyTemplateOption={Boolean(alert_timer_to_finish !== '')}
          setSelectedQuickMessage={receiveSelectedQuickMessage}
        />
      ) : (
        <QuickMessageSelector
          onUpdateMessage={updateText}
          text={currentText}
          onFocusInputText={setFocusOnInputText}
          onlyTemplate={alert_timer_to_finish !== ''}
        />
      )}
      {showCatalogCarousel ? (
        <div className="carouselContainer">
          <CatalogCarousel
            blockInteraction={blockInteraction}
            quickMessagesActivated={quickMessagesIsOpen}
          />
        </div>
      ) : null}
      {opennedChat.replying_message ? (
        <>
          <div className="replyMessageContainer">
            <div
              className="replyMessageText"
              style={{
                borderLeft: `5px solid ${setBgColorMessages(
                  opennedChat.contact.picture,
                  'replyInTextBox'
                )}`,
              }}
            >
              <p
                className="authorName"
                style={{
                  color: setBgColorMessages(
                    opennedChat.contact.picture,
                    'replyInTextBox'
                  ),
                }}
              >
                {opennedChat.replying_message.author_name}
              </p>
              {opennedChat.replying_message.documentType === 'image' ? (
                <img
                  src={
                    opennedChat.replying_message.thumb &&
                    opennedChat.replying_message.thumb !==
                      opennedChat.replying_message.url
                      ? `data:${opennedChat.replying_message.mimeType};base64,${opennedChat.replying_message.thumb}`
                      : opennedChat.replying_message.url
                  }
                  width={150}
                />
              ) : opennedChat.replying_message.documentType === 'ptt' ||
                opennedChat.replying_message.documentType === 'audio' ? (
                <div className="receivedMessageBalloon">
                  <Audio urlMedia={opennedChat.replying_message.url} />
                </div>
              ) : opennedChat.replying_message.documentType === 'video' ? (
                <video width={320} height={240} controls>
                  <source
                    src={opennedChat.replying_message.url}
                    type={opennedChat.replying_message.mimeType}
                  />
                  Your browser does not support the video tag.
                </video>
              ) : opennedChat.replying_message.documentType === 'document' ||
                opennedChat.replying_message.documentType === 'file' ? (
                <div>
                  <Icon
                    icon="poli-icon pi-file-fill"
                    size={40}
                    color="var(--primary-font-color)"
                  />
                  {opennedChat.replying_message.file_name ||
                    opennedChat.replying_message.caption ||
                    opennedChat.replying_message.text}
                </div>
              ) : opennedChat.replying_message.documentType === 'compacted' ? (
                <div>
                  <Icon
                    icon="poli-icon pi-zip-fill"
                    size={40}
                    color="var(--primary-font-color)"
                  />
                  {opennedChat.replying_message.file_name ||
                    opennedChat.replying_message.caption ||
                    opennedChat.replying_message.text}
                </div>
              ) : opennedChat.replying_message.documentType === 'compacted' ? (
                <div>
                  <Icon
                    icon="poli-icon pi-zip-fill"
                    size={40}
                    color="var(--primary-font-color)"
                  />
                  {opennedChat.replying_message.file_name ||
                    opennedChat.replying_message.caption ||
                    opennedChat.replying_message.text}
                </div>
              ) : opennedChat.replying_message.documentType === 'textEditor' ? (
                <div>
                  <Icon
                    icon="poli-icon pi-word-file-fill"
                    size={40}
                    color="var(--primary-font-color)"
                  />
                  {opennedChat.replying_message.file_name ||
                    opennedChat.replying_message.caption ||
                    opennedChat.replying_message.text}
                </div>
              ) : opennedChat.replying_message.documentType === 'textSheet' ? (
                <div>
                  <Icon
                    icon="poli-icon pi-excel-file-fill"
                    size={40}
                    color="var(--primary-font-color)"
                  />
                  {opennedChat.replying_message.file_name ||
                    opennedChat.replying_message.caption ||
                    opennedChat.replying_message.text}
                </div>
              ) : opennedChat.replying_message.documentType ===
                'apresentation' ? (
                <div>
                  <Icon
                    icon="poli-icon pi-apresentation-file-fill"
                    size={40}
                    color="var(--primary-font-color)"
                  />
                  {opennedChat.replying_message.file_name ||
                    opennedChat.replying_message.caption ||
                    opennedChat.replying_message.text}
                </div>
              ) : opennedChat.replying_message.documentType === 'pdf' ? (
                <div>
                  <Icon
                    icon="poli-icon pi-pdf-file-fill"
                    size={40}
                    color="var(--primary-font-color)"
                  />
                  {opennedChat.replying_message.file_name ||
                    opennedChat.replying_message.caption ||
                    opennedChat.replying_message.text}
                </div>
              ) : opennedChat.replying_message.documentType === 'link' ? (
                <div>
                  <Icon
                    icon="poli-icon pi-link-fill"
                    size={40}
                    color="var(--primary-font-color)"
                  />
                  <span>
                    {opennedChat.replying_message.url ||
                      opennedChat.replying_message.caption ||
                      opennedChat.replying_message.text}
                  </span>
                </div>
              ) : opennedChat.replying_message.documentType === 'location' ? (
                <span>
                  <Icon icon="poli-icon pi-location-line" size={15} />{' '}
                  Localização
                </span>
              ) : opennedChat.replying_message.documentType === 'vcard' ? (
                <span>
                  <Icon icon="poli-icon pi-contacts-line" size={15} /> Contato
                </span>
              ) : opennedChat.replying_message.documentType ===
                'multi_vcard' ? (
                <span>
                  <Icon icon="poli-icon pi-contacts-line" size={15} /> Contato
                </span>
              ) : opennedChat.replying_message.documentType === 'media' ? (
                <p className="text">{opennedChat.replying_message.text}</p>
              ) : opennedChat.replying_message.documentType === 'product' ? (
                <>
                  <img
                    style={{ marginRight: '20px', borderRadius: '8px' }}
                    src={
                      opennedChat.replying_message.product &&
                      opennedChat.replying_message.product?.picture &&
                      opennedChat.replying_message.product?.picture
                    }
                    width={100}
                    height={100}
                    alt={opennedChat.replying_message.product?.name}
                  />
                  <span>
                    {opennedChat.replying_message.product?.name
                      ? opennedChat.replying_message.product?.name
                      : 'Catalogo'}
                  </span>
                </>
              ) : opennedChat.replying_message.documentType ===
                'payment_link' ? (
                <>
                  <div
                    style={{
                      marginRight: '20px',
                      borderRadius: '8px',
                      background: 'white',
                      maxWidth: '60px',
                      textAlign: 'center',
                    }}
                  >
                    {opennedChat.replying_message.payment?.reference_type ===
                    'debt' ? (
                      <PayImage width="50" height="50" />
                    ) : (
                      <CartImage width="50" height="50" />
                    )}
                  </div>
                  <span>Pagamento</span>
                </>
              ) : (
                <p className="text">
                  {getMessageBuilderTemplateText(
                    opennedChat.replying_message.text
                  )}
                </p>
              )}
            </div>
            <Button
              border="border-none"
              color="link"
              onClick={() => {
                clearReplyingMessage({ chat_id: opennedChat.id });
              }}
            >
              <Icon icon="poli-icon pi-close-fill" size={24} color={'white'} />
            </Button>
          </div>
          {isTemplateApi ? (
            <Alert color="danger" className="alert-no-reply">
              <Icon icon="poli-icon pi-alert-fill" /> Canais do tipo WABA não
              permitem o uso de respostas
            </Alert>
          ) : null}
        </>
      ) : null}

      {!(
        isTemplateSelected ||
        isTemplateListSelected ||
        isButtonsMessageSelected
      ) &&
        urlPreview?.length > 1 && (
          <div className="previewLink">
            <ReactTinyLink
              cardSize="small"
              showGraphic={true}
              maxLine={2}
              minLine={1}
              url={urlPreview}
              proxyUrl={`${process.env?.REACT_APP_API_GATEWAY_HOST}/proxy`}
            />
          </div>
        )}

      {((isTemplateApi &&
        (isTemplateSelected ||
          isTemplateListSelected ||
          isButtonsMessageSelected)) ||
        (opennedChat?.view?.selectedChannel?.api == 4 &&
          (isTemplateListSelected || isButtonsMessageSelected))) &&
        urlPreview && (
          <PreviewThumbnail
            click={() => {
              handleClickPreviewThumb;
            }}
            media={mediaLink}
            type={mediaFormat}
            header={headerPreview}
            body={bodyPreview}
            footer={footerPreview}
          />
        )}

      {!isTemplateApi && isTemplateSelected && (
        <Alert color="danger" className="alert-timer-to-finish">
          <Icon icon="poli-icon pi-alert-fill" /> Templates só podem ser
          enviados pelo canal WABA. Utilize uma mensagem rápida para conversar
          por este canal.
        </Alert>
      )}

      {/* TODO: rever texto com o time */}
      {!canOpenActiveChat && isZapiOrWebchat && (
        <Alert color="danger" className="alert-timer-to-finish">
          <Icon icon="poli-icon pi-alert-fill" /> conversas ativamente fora da
          janela de 24 horas.
        </Alert>
      )}

      {/* TODO: rever texto com o time */}
      {!canOpenActiveChat && isZapiOrWebchat && (
        <Alert color="danger" className="alert-timer-to-finish">
          <Icon icon="poli-icon pi-alert-fill" /> conversas ativamente fora da
          janela de 24 horas.
        </Alert>
      )}
      {flags.new_channel_selector?.enabled && <ChannelSelectorNew />}
      <div className="textBoxContainer">
        <div className="groupTextArea">
          {settings.can_send_audio ? (
            <RecordAudioBase64
              recording={recordingAudio}
              onSend={onSendAudioBase64}
              onChangeRecording={recordingAudioToggle}
            />
          ) : null}
          {!flags.new_channel_selector?.enabled && <ChannelSelector />}

          {showImproveAnswerButton() && (
            <>
              <Button
                type="button"
                color="link"
                className="improveMessageBtn"
                id="tooltipCopilotBtnImproveMessage"
                onClick={() => {
                  handleImproveMessage();
                  if (opennedChat?.id) {
                    sendTrigger({
                      entity_id: opennedChat?.id,
                      entity_type: 'contact',
                      type: triggerTypes.CREATED,
                      origin: 'antiga-interface',
                      payload: {
                        component: 'ImproveAnswerComponent',
                        hook: null,
                        element: 'button-clicked-create-improve-answer',
                      },
                    });
                  }
                }}
              >
                <span role="img" aria-label="copilot">
                  <StarsFillIcon />
                </span>
                Melhorar resposta
              </Button>
              <ModalImproveAnswerSettings
                isOpen={true}
                onClose={handleCloseImproveAnswerSettings}
                id="modalImproveAnswerSettings"
                style={{
                  positionAnchor: '--btn-melhorar-resposta',
                }}
                onImproveAnswer={handleOpenImproveAnswerSettings}
              />
            </>
          )}

          <div className="textBoxMessage">
            {validationPermissionSendTextArea ? (
              <div className="input-box">{getCurrentText()}</div>
            ) : (
              <div className="textAreaBox">
                {!isSuggestedText && !recordingAudio && (
                  <CopilotAnswerComponent
                    isWindow24Open={isWindow24Open}
                    isEnabledByUserSettings={isEnabledByUserSettings}
                    onClose={() => {
                      setIsSuggestedText(false);
                      setIsSuggestedByAIDiscarded(true);
                    }}
                    onSelectSuggestion={(suggestionText) => {
                      handleCloseCopilotModal();
                      updateText(suggestionText);
                      setIsSuggestedText(true);
                      setIsSuggestedByAI(true);
                      setIsSuggestedByAIDiscarded(false);
                    }}
                  />
                )}

                <div style={{ position: 'relative' }}>
                  <div className="textBoxButtons">
                    {currentText.length &&
                    !(showCatalog && showCatalogCarousel) &&
                    !recordingAudio ? (
                      <Button
                        border="border-none"
                        color="link"
                        onClick={() => {
                          setIsSuggestedText(false);
                          setIsImprovedText(false);
                          setIsImproveAnswerSettingsOpen(false);
                          updateText('');

                          if (isSuggestedByAI) {
                            setIsSuggestedByAIDiscarded(true);
                          }
                        }}
                        id="tooltipClearMessage"
                        className="clearMessageText"
                      >
                        <UncontrolledTooltip
                          placement="bottom"
                          target="tooltipClearMessage"
                        >
                          Limpar mensagem
                        </UncontrolledTooltip>
                        <Icon
                          icon={'poli-icon pi-close-line'}
                          color="var(--red-polichat)"
                          size={20}
                        />
                      </Button>
                    ) : null}
                  </div>

                  <Input
                    disabled={
                      validationPermissionSendTextArea ||
                      isSuspended ||
                      shouldBlockWabaAt100
                    }
                    style={{
                      cursor: isLoadingCustomerChannelContext ? 'wait' : null,
                    }}
                    type="textarea"
                    name=""
                    id="textAreaMessage"
                    value={getCurrentText()}
                    onChange={(event) => {
                      updateText(event.target.value);
                      setIsImprovedText(false);
                      setIsSuggestedText(false);
                    }}
                    className={`textAreaMessage f-control ${
                      isImprovedText ? 'improved-text' : ''
                    }`}
                    placeholder="Aa"
                    // onClick={(event) => verifyHasOwner(event)}
                    onKeyPress={(event) => wrapperKeyPressEvent(event)}
                    onKeyDown={(event) => wrapperKeyDownEvent(event)}
                    onInput={(event) => wrapperInputEvent(event)}
                    onFocus={() => setFocusedTextArea('textbox')}
                  />

                  {isImprovedText && (
                    <div className="improveAnswerActions">
                      <Button
                        outline
                        color="primary"
                        onClick={() => {
                          handleUndoImproveAnswer();
                          if (opennedChat?.id) {
                            sendTrigger({
                              entity_id: opennedChat?.id,
                              entity_type: 'contact',
                              type: triggerTypes.CLICKED,
                              origin: 'antiga-interface',
                              payload: {
                                component: 'ImproveAnswerComponent',
                                hook: null,
                                element: 'button-clicked-undo-improve-answer',
                              },
                            });
                          }
                        }}
                        className="improveAnswerActionsButton improveAnswerActionsButton--Undo"
                      >
                        Desfazer
                      </Button>

                      <Button
                        onClick={() => {
                          handleImproveMessage();
                          if (opennedChat?.id) {
                            sendTrigger({
                              entity_id: opennedChat?.id,
                              entity_type: 'contact',
                              type: triggerTypes.CLICKED,
                              origin: 'antiga-interface',
                              payload: {
                                component: 'ImproveAnswerComponent',
                                hook: null,
                                element:
                                  'button-clicked-generate-new-improve-answer',
                              },
                            });
                          }
                        }}
                        className="improveAnswerActionsButton improveAnswerActionsButton--New"
                      >
                        Gerar nova
                      </Button>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>

          {/* Renderiza o formulário de agendamento */}
          {showSchedulingForm && step !== 0 && (
            <TaskSecondStep
              date={scheduleData.date}
              time={scheduleData.time}
              handleChange={handleScheduleChange}
              nextStep={nextStep}
              prevStep={prevStep}
              step={step}
              cancelScheduling={cancelScheduling}
              handleSubmit={handleScheduleSubmit}
              messageScheduling={messageScheduling}
              setMessageScheduling={setMessageScheduling}
              setTemplateSelectedUuid={setTemplateSelectedUuid}
            />
          )}
        </div>
      </div>

      <div className="groupActions">
        <div className="groupActionsLeft">
          {!isMobile && (
            <Dropdown
              direction="up"
              isOpen={fontStylesSwitch}
              toggle={() =>
                setFontStylesSwitch((fontStylesSwitch) => !fontStylesSwitch)
              }
            >
              <DropdownToggle color="link">
                <Icon
                  icon="poli-icon pi-text-fast-fill"
                  size={20}
                  color={'var(--principal-icons-color)'}
                />
              </DropdownToggle>
              <DropdownMenu className="dropdownFontStyles">
                <DropdownItem
                  onClick={() =>
                    handleStyleBold(window.getSelection().toString())
                  }
                >
                  <Icon icon={'poli-icon pi-bold-fill'} size={20} />
                  <span style={{ fontWeight: 'bold' }}>{boldText}</span>
                </DropdownItem>

                <DropdownItem
                  onClick={() =>
                    handleStyleItalic(window.getSelection().toString())
                  }
                >
                  <Icon icon={'poli-icon pi-italic-fill'} size={20} />
                  <span style={{ fontStyle: 'italic' }}>{italicText}</span>
                </DropdownItem>

                <DropdownItem
                  onClick={() =>
                    handleStyleStrike(window.getSelection().toString())
                  }
                >
                  <Icon icon={'poli-icon pi-strike-fill'} size={20} />
                  <span style={{ textDecoration: 'line-through' }}>
                    {strikethroughText}
                  </span>
                </DropdownItem>

                <DropdownItem
                  onClick={() =>
                    handleStyleCode(window.getSelection().toString())
                  }
                >
                  <Icon icon={'poli-icon pi-type-code-fill'} size={20} />
                  <span>{codeText}</span>
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          )}

          {channels && canChat && opennedChat.contact.externals.length > 0 ? (
            <div className="contactExternalContainer">
              <ContactExternalSelector />
            </div>
          ) : (
            ''
          )}
        </div>

        {showCustomBoxWL ? <CustomBox local="footChat" /> : <></>}
        <div className="groupActionsRight">
          {showCart ? <CartPanel blockInteraction={blockInteraction} /> : null}

          {!isWhiteLabel &&
            (showCatalog ? (
              showCatalogCarousel ? (
                <Button
                  border="border-none"
                  color="link"
                  onClick={handleCloseCatalog}
                  id="tooltipCatalog"
                >
                  <UncontrolledTooltip
                    placement="bottom"
                    target="tooltipCatalog"
                  >
                    {closeCatalogText}
                  </UncontrolledTooltip>
                  <Icon
                    icon={'poli-icon pi-close-line'}
                    color="var(--red-polichat)"
                    size={20}
                  />
                </Button>
              ) : (
                <Button
                  border="border-none"
                  color="link"
                  onClick={handleOpenCatalog}
                  id="tooltipCatalog"
                  disabled={shouldBlockWabaAt100}
                >
                  <UncontrolledTooltip
                    placement="bottom"
                    target="tooltipCatalog"
                  >
                    {catalogText}
                  </UncontrolledTooltip>
                  <Icon
                    icon={'poli-icon pi-catalogo-fill'}
                    color="var(--principal-icons-color)"
                    size={20}
                  />
                </Button>
              )
            ) : null)}

          {settings.can_send_file ? (
            <Button
              border="border-none"
              color="link"
              id="tooltipUploadFiles"
              className="buttonUploadFiles"
              onClick={(e) => {
                if (blockInteraction) return;
                e.preventDefault();
                updateChatDropzone(opennedChat.id, true, true);
                closeCatalogCarousel();
              }}
              disabled={
                !isUserAbleToSendMessage ||
                blockInteraction ||
                shouldBlockWabaAt100
              }
            >
              <UncontrolledTooltip
                placement="bottom"
                target="tooltipUploadFiles"
              >
                {uploadFileText}
              </UncontrolledTooltip>
              <Icon
                icon={'poli-icon pi-attach-fill'}
                size={20}
                color={'var(--principal-icons-color)'}
              />
            </Button>
          ) : null}
          <Button
            border="border-none"
            color="link"
            onClick={() => {
              if (isSuspended) return;
              setFocusOnInputText();
              setEmojiPicker(false);
              toggleQuickMessagesSelector();
              closeCatalogCarousel();
            }}
            className="buttonHandleQuickMessages"
            id="buttonHandleQuickMessages"
            disabled={!isUserAbleToSendMessage || shouldBlockWabaAt100}
          >
            <UncontrolledTooltip
              placement="bottom"
              target="buttonHandleQuickMessages"
            >
              {sendTemplateOrQuickMessageText}
            </UncontrolledTooltip>
            <Icon
              icon={'poli-icon pi-rocket-fill'}
              size={20}
              color={'var(--principal-icons-color)'}
            />
          </Button>
          {emojiPickerState === false ? (
            <Button
              border="border-none"
              color="link"
              onClick={(e) => {
                if (blockInteraction) return;
                triggerPicker(e);
              }}
              className="buttonHandleEmoji"
              id="buttonHandleEmoji"
              disabled={
                !isUserAbleToSendMessage ||
                blockInteraction ||
                isSuspended ||
                shouldBlockWabaAt100
              }
            >
              <UncontrolledTooltip
                placement="bottom"
                target="buttonHandleEmoji"
              >
                {openEmojiPickerText}
              </UncontrolledTooltip>
              <Icon
                icon={'poli-icon pi-smille-fill'}
                size={20}
                color={'var(--principal-icons-color)'}
              />
            </Button>
          ) : (
            <Button
              border="border-none"
              color="link"
              className="buttonHandleEmoji"
              id="buttonHandleEmoji"
              onClick={closePickerEmoji}
            >
              <UncontrolledTooltip
                placement="bottom"
                target="buttonHandleEmoji"
              >
                {closeEmojiPickerText}
              </UncontrolledTooltip>
              <Icon
                icon={'poli-icon pi-close-line'}
                color="var(--red-polichat)"
                size={20}
              />
            </Button>
          )}
          {settings.can_send_audio &&
          isUserAbleToSendMessage &&
          !shouldBlockWabaAt100 &&
          !poliConfig.channelsCantSendAudioMessage.includes(
            opennedChat?.view?.selectedChannel?.type
          ) ? (
            <ButtonRecordAudio
              blockInteraction={blockInteraction}
              recording={recordingAudio}
              onChangeRecording={recordingAudioToggle}
              emojiActivated={emojiPickerState}
              quickMessagesActivated={quickMessagesIsOpen}
            />
          ) : null}
          {scheduleMessageFlag && (
            <Button
              disabled={isSuspended || shouldBlockWabaAt100}
              id="buttonHandleSchedule"
              border="border-none"
              color="link"
              onClick={toggleSchedulingForm}
              title={
                !currentText
                  ? selectMessageOrTemplateText
                  : scheduleMessageTitleText
              }
            >
              <UncontrolledTooltip
                placement="bottom"
                target="buttonHandleSchedule"
              >
                {scheduleMessageTitleText}
              </UncontrolledTooltip>
              <Icon icon="poli-icon pi-day-fill" size={20} />
            </Button>
          )}
          <Button
            id="sendMessageButton"
            border="border-none"
            color="link"
            disabled={blockSendMessageButton || isSuspended}
            onClick={() => sendMessageEvent()}
            title="Enviar"
          >
            <Icon
              icon={'poli-icon pi-set-fill'}
              color="var(--icon-color-font)"
              size={20}
            />
          </Button>
        </div>
      </div>
    </>
  );
}
const mapStateToProps = (state) => ({
  chat: state.chat,
  crm: state.chat.config.general?.crm,
  customerOnboarding: state?.general?.user?.customer_onboarding,
  opennedChat:
    state.chat?.chats?.filter((chat) => {
      return chat.open === true;
    })[0] || [],
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(ChatActions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(TextBox);
